import React from "react";

import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import {
	Box,
	IconButton,
	Slider,
	Stack,
	Typography,
	useTheme,
} from "@mui/material";

export default function SidebarSlider({
	title,
	min,
	max,
	step,
	value,
	updateValue,
	incrementLabel="Increment",
	decrementLabel="Decrement",
}) {
	const increment = (event) => {
		if (value < max) {
			updateValue(Math.min(value+step, max))
		}
	};

	const decrement = (event) => {
		if (value > min) {
			updateValue(Math.max(value-step, min))
		}
	};

	const setValue = (event) => {
		updateValue(event.target.value)
	}

	const theme = useTheme();

	return (
		<Box sx={{
			mb: 1,
			ml: 3,
		}}>
			<Typography variant="caption">
				{title}:
			</Typography>
			<Stack
				spacing={2}
				direction="row"
				sx={{
					mb: 1,
					ml: 3,
					width: "350px",
					maxWidth: `calc(100% - ${theme.spacing(4)})`,
				}}
				alignItems="center">
				<IconButton
					onClick={decrement}
					disabled={value <= min}
					color="primary"
					aria-label={decrementLabel}>
					<RemoveCircleIcon />
				</IconButton>
				<Slider
					size="small"
					value={value}
					aria-label={title}
					max={max}
					min={min}
					step={step}
					onChange={setValue}
					marks />
				<IconButton
					onClick={increment}
					disabled={value >= max}
					color="primary"
					aria-label={incrementLabel}>
					<AddCircleIcon />
				</IconButton>
			</Stack>
		</Box>
	)
}